import { makeBetterEnum } from './betterEnum';

export const LineageAssetKind = makeBetterEnum(
  'ParquetFileMetadata',
  'DataRegistryTable',
  'Bart',
  'ExtBart',
  'FileMetadata',
  'ActivityDatasetVersion'
);

export type LineageAssetKind =
  (typeof LineageAssetKind)[keyof typeof LineageAssetKind];

export const AdminLineageDirection = makeBetterEnum('Upstream', 'Downstream');

export const LineageDirection = makeBetterEnum(
  'Upstream',
  'Downstream',
  'Self'
);
